import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from '../../../page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';

@Injectable({
	providedIn: 'root',
})
export class RequestCustomfieldService {
	private getCustomfieldByClassificationUrl =
		environment.baseApiUrl + 'request/customField/search/{idTopic}/{idCategory}/{idSolutionArea}';
	private getCustomfieldByCategoriesUrl = environment.baseApiUrl + 'request/customField/search?${idCategories}';
	private getCustomfieldByRequestUrl = environment.baseApiUrl + 'request/{idRequest}/customField';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getCustomfieldsByClassification(idTopic: string, idCategory: string, idSolutionArea: string): Observable<genericFormInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getCustomfieldUrl = this.getCustomfieldByClassificationUrl
			.replace('{idTopic}', idTopic)
			.replace('{idCategory}', idCategory)
			.replace('{idSolutionArea}', idSolutionArea);
		return this.http.get(getCustomfieldUrl, { headers: headers }).pipe(
			map((customfieldRes: any) => {
				const newCustomfieldArray: genericFormInterface[] = [];
				for (const customfield of customfieldRes) {
					const newCustomfield: genericFormInterface = {
						id: customfield.id_request_field,
						name: customfield.request_field,
						label: customfield.request_field,
						fieldType: customfield.field_type,
						inputType: this.formatType(customfield.field_type),
						rawInputType: this.formatType(customfield.field_type),
						required: customfield.required,
						rawRequired: customfield.required,
						hidden: customfield.hidden_field,
						rawHidden: customfield.hidden_field,
						analystView: customfield.analyst_view,
						relatedTask: customfield.related_task,
						items: [],
						values: [],
						rawValues: [],
					};

					for (const value of customfield.field_values) {
						const newItem: genericFormInterface['items'][number] = {
							value: value.value_item,
							values: [value.value_item],
							id: value.text_item,
							name: value.text_item,
							label: value.text_item,
							subSelect: [],
						};

						if (value.related_request_field != '') {
							const subSelectArray = value.related_request_field.split(',');
							for (const subSelect of subSelectArray) {
								newItem.subSelect.push({
									subSelectChildName: subSelect,
									subSelectQryName: '',
									parameters: [],
								});
							}
						}

						if (value.related_request_field_required != '') {
							const related_request_field_requiredArray = value.related_request_field_required.split(',');
							for (const subSelect of newItem.subSelect) {
								if (related_request_field_requiredArray.includes(subSelect.subSelectChildName))
									subSelect['make_required'] = true;
							}
						}

						newCustomfield.items.push(newItem);
					}

					if (newCustomfield.inputType == 'attachment') {
						newCustomfield.fileSource = 'request';
						if (newCustomfield.values[0]) newCustomfield.values[0] = this.formatAttachPath(newCustomfield.values[0]);
					} else if (newCustomfield.inputType == 'multi-select' || newCustomfield.inputType == 'radio') {
						newCustomfield.stringifiedValue = '';
						newCustomfield.rawValues = customfield.request_field_value ? customfield.request_field_value.split('§') : [];
						for (const item of newCustomfield.items) {
							if (newCustomfield.rawValues.includes(item.values[0])) newCustomfield.values.push(item);
						}
						newCustomfield.stringifiedValue = newCustomfield.values
							.map((v) => {
								return v.values[0];
							})
							.join(', ');
					} else if (newCustomfield.inputType == 'checkbox') {
						newCustomfield.stringifiedValue = '';
						newCustomfield.rawValues = customfield.request_field_value
							? customfield.request_field_value.split('§')
							: Array.from({ length: newCustomfield.items.length }).fill(0);
						for (const [index, value] of newCustomfield.rawValues.entries()) {
							if (value.toString().trim() == '') {
								newCustomfield.values[index] = 0;
							} else {
								newCustomfield.values[index] = 1;
								newCustomfield.stringifiedValue += newCustomfield.rawValues[index] + ', ';
							}
						}
						newCustomfield.stringifiedValue = newCustomfield.stringifiedValue.slice(0, -2);
					} else if (newCustomfield.inputType == 'json_dynamic') {
						this.buildJsonDynamicItems(newCustomfield, customfield);
					} else if (customfield.request_field_value) {
						newCustomfield.values = [customfield.request_field_value];
					}

					newCustomfieldArray.push(newCustomfield);
				}

				return newCustomfieldArray;
			})
		);
	}

	getCustomfieldsByCategoryOnly(idCategory: string[]): Observable<genericFormInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getCustomfieldUrl = this.getCustomfieldByCategoriesUrl.replace('{idCategories}', idCategory.join(','));
		return this.http.get<genericFormInterface[]>(getCustomfieldUrl, { headers: headers }).pipe(
			map((customfieldRes: any) => {
				const newCustomfieldArray: genericFormInterface[] = [];
				for (const customfield of customfieldRes) {
					const newCustomfield: genericFormInterface = {
						id: customfield.id_request_field,
						name: customfield.request_field,
						label: customfield.request_field,
						fieldType: customfield.field_type,
						inputType: this.formatType(customfield.field_type),
						rawInputType: this.formatType(customfield.field_type),
						required: customfield.required,
						rawRequired: customfield.required,
						hidden: customfield.hidden_field,
						rawHidden: customfield.hidden_field,
						analystView: customfield.analyst_view,
						items: [],
						values: [],
						rawValues: [],
					};

					for (const value of customfield.field_values) {
						const newItem: genericFormInterface['items'][number] = {
							value: value.value_item,
							values: [value.value_item],
							id: value.text_item,
							name: value.text_item,
							label: value.text_item,
							subSelect: [],
						};

						if (value.related_request_field != '') {
							const subSelectArray = value.related_request_field.split(',');
							for (const subSelect of subSelectArray) {
								newItem.subSelect.push({
									subSelectChildName: subSelect,
									subSelectQryName: '',
									parameters: [],
								});
							}
						}

						if (value.related_request_field_required != '') {
							const related_request_field_requiredArray = value.related_request_field_required.split(',');
							for (const subSelect of newItem.subSelect) {
								if (related_request_field_requiredArray.includes(subSelect.subSelectChildName))
									subSelect['make_required'] = true;
							}
						}

						newCustomfield.items.push(newItem);
					}

					if (newCustomfield.inputType == 'attachment') {
						newCustomfield.fileSource = 'request';
						if (newCustomfield.values[0]) newCustomfield.values[0] = this.formatAttachPath(newCustomfield.values[0]);
					} else if (newCustomfield.inputType == 'multi-select' || newCustomfield.inputType == 'radio') {
						newCustomfield.rawValues = customfield.request_field_value ? customfield.request_field_value.split('§') : [];
						for (const item of newCustomfield.items) {
							if (newCustomfield.rawValues.includes(item.values[0])) newCustomfield.values.push(item);
						}
						newCustomfield.stringifiedValue = newCustomfield.values
							.map((v) => {
								return v.values[0];
							})
							.join(', ');
					} else if (newCustomfield.inputType == 'checkbox') {
						newCustomfield.stringifiedValue = '';
						newCustomfield.rawValues = customfield.request_field_value
							? customfield.request_field_value.split('§')
							: Array.from({ length: newCustomfield.items.length }).fill(0);
						for (const [index, value] of newCustomfield.rawValues.entries()) {
							if (value.toString().trim() == '') {
								newCustomfield.values[index] = 0;
							} else {
								newCustomfield.values[index] = 1;
								newCustomfield.stringifiedValue += newCustomfield.rawValues[index] + ', ';
							}
						}
						newCustomfield.stringifiedValue = newCustomfield.stringifiedValue.slice(0, -2);
					} else if (newCustomfield.inputType == 'json_dynamic') {
						this.buildJsonDynamicItems(newCustomfield, customfield);
					} else if (customfield.request_field_value) {
						newCustomfield.values = [customfield.request_field_value];
					}

					newCustomfieldArray.push(newCustomfield);
				}

				return newCustomfieldArray;
			})
		);
	}

	getCustomfieldsByRequest(idRequest: string): Observable<genericFormInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getCustomfieldByRequestUrl = this.getCustomfieldByRequestUrl.replace('{idRequest}', idRequest);
		return this.http.get(getCustomfieldByRequestUrl, { headers: headers }).pipe(
			map((customfieldRes: any) => {
				const abc = new genericFormI('item');

				const newCustomfieldArray: genericFormInterface[] = [];
				for (const customfield of customfieldRes) {
					const newCustomfield: genericFormInterface = {
						id: customfield.id_request_field,
						name: customfield.request_field,
						label: customfield.request_field,
						fieldType: customfield.field_type,
						inputType: this.formatType(customfield.field_type),
						rawInputType: this.formatType(customfield.field_type),
						required: customfield.required,
						rawRequired: customfield.required,
						hidden: customfield.hidden_field,
						rawHidden: customfield.hidden_field,
						analystView: customfield.analyst_view,
						relatedTask: customfield.related_task,
						disabled: customfield.disabled,
						items: [],
						values: [],
						rawValues: [],
					};

					for (const value of customfield.field_values) {
						const newItem: genericFormInterface['items'][number] = {
							value: value.value_item,
							values: [value.value_item],
							id: value.text_item,
							name: value.text_item,
							label: value.text_item,
							subSelect: [],
						};

						if (value.related_request_field != '') {
							const subSelectArray = value.related_request_field.split(',');
							for (const subSelect of subSelectArray) {
								newItem.subSelect.push({
									subSelectChildName: subSelect,
									subSelectQryName: '',
									parameters: [],
								});
							}
						}

						if (value.related_request_field_required != '') {
							const related_request_field_requiredArray = value.related_request_field_required.split(',');
							for (const subSelect of newItem.subSelect) {
								if (related_request_field_requiredArray.includes(subSelect.subSelectChildName))
									subSelect['make_required'] = true;
							}
						}

						newCustomfield.items.push(newItem);
					}

					if (newCustomfield.inputType == 'attachment') {
						newCustomfield.fileSource = 'request';
						if (customfield.request_field_value)
							newCustomfield.values[0] = this.formatAttachPath(customfield.request_field_value);
					} else if (newCustomfield.inputType == 'multi-select' || newCustomfield.inputType == 'radio') {
						newCustomfield.rawValues = customfield.request_field_value ? customfield.request_field_value.split('§') : [];
						for (const item of newCustomfield.items) {
							if (newCustomfield.rawValues.includes(item.values[0])) newCustomfield.values.push(item);
						}
						newCustomfield.stringifiedValue = newCustomfield.values
							.map((v) => {
								return v.values[0];
							})
							.join(', ');
					} else if (newCustomfield.inputType == 'checkbox') {
						newCustomfield.stringifiedValue = '';
						newCustomfield.rawValues = customfield.request_field_value
							? customfield.request_field_value.split('§')
							: Array.from({ length: newCustomfield.items.length }).fill(0);
						for (const [index, value] of newCustomfield.rawValues.entries()) {
							if (value.toString().trim() == '') {
								newCustomfield.values[index] = 0;
							} else {
								newCustomfield.values[index] = 1;
								newCustomfield.stringifiedValue += newCustomfield.rawValues[index] + ', ';
							}
						}
						newCustomfield.stringifiedValue = newCustomfield.stringifiedValue.slice(0, -2);
					} else if (newCustomfield.inputType == 'json_dynamic') {
						this.buildJsonDynamicItems(newCustomfield, customfield);
					} else if (customfield.request_field_value) {
						newCustomfield.values = [customfield.request_field_value];
					}

					newCustomfieldArray.push(newCustomfield);
				}

				return newCustomfieldArray;
			})
		);
	}

	/** Constrói os items de um campo json_dynamic a partir do JSON armazenado no backend */
	private buildJsonDynamicItems(newCustomfield: genericFormInterface, customfield: any): void {
		if (newCustomfield.items.length === 0 || !newCustomfield.items[0].values[0]) return;
		try {
			const rawJson: string = newCustomfield.items[0].values[0];
			const displayKeys: string[] = (newCustomfield.items[0].id as string).split(',').map((k: string) => k.trim());
			const jsonArray: any[] = JSON.parse(rawJson);
			newCustomfield.displayKeys = displayKeys;
			newCustomfield.items = jsonArray.map((object: any, index: number) => {
				const autoId = index + 1;
				const labelParts = displayKeys.map((k) => object[k] ?? '').filter(Boolean);
				return {
					id: autoId,
					name: labelParts.join(' - '),
					label: labelParts.join(' - '),
					values: [autoId],
					value: autoId,
					data: object,
					subSelect: [],
				};
			});
		} catch {
			newCustomfield.items = [];
		}

		if (customfield.request_field_value) {
			// Formato novo: valor é o texto do label
			const matchedByLabel = newCustomfield.items.find((item: any) => (item.label ?? item.name) === customfield.request_field_value);
			if (matchedByLabel) {
				newCustomfield.values = [matchedByLabel.id];
				newCustomfield.rawValues = [customfield.request_field_value];
				return;
			}
			// Compat retroativa: valor pode ser o JSON completo do objeto
			try {
				const saved = JSON.parse(customfield.request_field_value);
				if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
					const matchedItem = newCustomfield.items.find((item: any) => {
						return JSON.stringify(item.data) === JSON.stringify(saved);
					});
					if (matchedItem) {
						newCustomfield.values = [matchedItem.id];
						// Migra para o novo formato (label text)
						newCustomfield.rawValues = [matchedItem.label ?? matchedItem.name ?? customfield.request_field_value];
					}
					return;
				}
			} catch {}
			// Legado: valor é o índice numérico
			newCustomfield.values = [customfield.request_field_value];
		}
	}

	formatType(type: string): string {
		type = type.toLowerCase();
		if (type === 'text') return 'string';
		if (type === 'select') return 'select-iac';
		if (type === 'select-approver') return 'select-iac';
		if (type === 'multi-select') return 'multi-select';
		if (type === 'select-approver') return 'select-approver';
		if (type === 'radio') return 'radio';
		if (type === 'checkbox') return 'checkbox';
		if (type === 'int') return 'number';
		if (type === 'attachment') return 'attachment';
		if (type === 'json_dynamic') return 'json_dynamic';

		return type;
	}

	formatAttachPath(filePath: string): string {
		if (filePath) {
			let splitedFilePath = [];
			splitedFilePath = filePath.includes('\\') ? filePath.split('\\') : filePath.split('/');

			return splitedFilePath.at(-1);
		}

		return '';
	}
}
